import { render, staticRenderFns } from "./receiveDetail.vue?vue&type=template&id=d5e62634&scoped=true"
import script from "./receiveDetail.vue?vue&type=script&lang=js"
export * from "./receiveDetail.vue?vue&type=script&lang=js"
import style0 from "./receiveDetail.vue?vue&type=style&index=0&id=d5e62634&lang=scss"
import style1 from "./receiveDetail.vue?vue&type=style&index=1&id=d5e62634&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e62634",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5e62634')) {
      api.createRecord('d5e62634', component.options)
    } else {
      api.reload('d5e62634', component.options)
    }
    module.hot.accept("./receiveDetail.vue?vue&type=template&id=d5e62634&scoped=true", function () {
      api.rerender('d5e62634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platformCouponManage/receiveDetail.vue"
export default component.exports